module.exports = __webpack_public_path__ + "img/eng-lqtafsir-2.8a7a4f0d.webp";